import React from 'react';
import Records from './records';

const WithdrawRecords = () => {
  return <Records type="withdraw" />;
};

export default WithdrawRecords;
